var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.key,staticClass:"nav-item"},[_c('a',{directives:[{name:"t",rawName:"v-t",value:(tab.text),expression:"tab.text"}],staticClass:"nav-link",class:{ active: tab.key === _vm.curtab },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.curtab=tab.key}}})])})),_vm._v(" "),_vm._t(_vm.curtab)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d229b20","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs.vue
// module id = 26
// module chunks = 2